import { render, staticRenderFns } from "./HBox.vue?vue&type=template&id=fdc14ae6&scoped=true&"
import script from "./HBox.vue?vue&type=script&lang=js&"
export * from "./HBox.vue?vue&type=script&lang=js&"
import style0 from "./HBox.vue?vue&type=style&index=0&id=fdc14ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc14ae6",
  null
  
)

export default component.exports